import React, { useContext } from 'react';
import { Communication } from '@fluentui/react-teams';
import { RenderSkeleton } from './RenderSkeleton';
import { Board } from '../Board';
import { Report } from '../Report';
import { List } from '../List/List';
import { AppStateContext } from '../../AppState';
import { Ticket } from '../../shared/interfaces/ticket.interface';
import { toggleButtonMapper, ViewType } from '../ticketHelper';

interface Props {
  isTicketsFetching: boolean;
  page: string;
  onTicketsSelected: (tickets: Ticket[]) => void;
  defaultFilters: FilterPropsItems[];
  listFeatureStates: ListFeatureStates;
}

export const TicketBoardView = ({
  isTicketsFetching,
  page,
  onTicketsSelected,
  defaultFilters,
  listFeatureStates
}: Props) => {
  const state = useContext(AppStateContext);

  return (
    <>
      {isTicketsFetching || state.isReload ? (
        <RenderSkeleton page={page} />
      ) : !isTicketsFetching && state.isError ? (
        <Communication {...state.errorConfig} />
      ) : page === toggleButtonMapper[ViewType.board] ? (
        <Board defaultFilters={defaultFilters} listFeatureStates={listFeatureStates} />
      ) : page === toggleButtonMapper[ViewType.chart] ? (
        <Report />
      ) : (
        <List onTicketsSelected={onTicketsSelected} listFeatureStates={listFeatureStates} defaultFilters={defaultFilters}/>
      )}
    </>
  );
};
